module.exports = "//img1.rrcimg.com/_next/static/src/assets/yanxuan-icon_2pJ-s.png";